import Icon from '../components/Icon.vue'

Icon.register({
  fax: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M64 128H32C14.3 128 0 142.3 0 160V480C0 497.7 14.3 512 32 512H64C81.7 512 96 497.7 96 480V160C96 142.3 81.7 128 64 128zM480 160V77.3C480 68.8 476.6 60.6 470.6 54.6L425.4 9.4C419.4 3.4 411.2 0 402.7 0H160C142.3 0 128 14.3 128 32V480C128 497.7 142.3 512 160 512H480C497.7 512 512 497.7 512 480V192C512 174.3 497.7 160 480 160zM288 432C288 440.8 280.8 448 272 448H240C231.2 448 224 440.8 224 432V400C224 391.2 231.2 384 240 384H272C280.8 384 288 391.2 288 400V432zM288 304C288 312.8 280.8 320 272 320H240C231.2 320 224 312.8 224 304V272C224 263.2 231.2 256 240 256H272C280.8 256 288 263.2 288 272V304zM416 432C416 440.8 408.8 448 400 448H368C359.2 448 352 440.8 352 432V400C352 391.2 359.2 384 368 384H400C408.8 384 416 391.2 416 400V432zM416 304C416 312.8 408.8 320 400 320H368C359.2 320 352 312.8 352 304V272C352 263.2 359.2 256 368 256H400C408.8 256 416 263.2 416 272V304zM432 192H176V48H384V80C384 88.8 391.2 96 400 96H432V192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fax.js
// module id = t/Q5
// module chunks = 144